// extracted by mini-css-extract-plugin
export default {"main-container-flex":"PrivacyModal_main-container-flex__3g05R"};